
// Product Schema
export function findInArrayByKey(array, key, value) {

    if (!Array.isArray(array)) {
        return false;
    }

    let element = null;

    array.map(function (item, index) {

        if (item[key] == value) {
            element = item;
        }

    });

    return element;
}

export function removeCountryFromList(addressList: string[]) {
    // Define the country names to check
    const countriesToRemove = ["nederland", "netherlands", "belgië", "belgium"];

    // Filter out any matching country names
    const filteredList = addressList.filter(item => 
        !countriesToRemove.includes(item.toLocaleLowerCase())
    );

    return filteredList;
}
